var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bleach-site active-banner",class:[
    {
      'show-banner': _vm.showBanner && !_vm.disableBanner,
      'cart-alert-active': _vm.alertActive
    },
    `breakpoint--${_vm.GET_CURRENT_BREAKPOINT.breakpoint}`
  ]},[(_vm.GET_SHOW_GLOBAL_ERROR)?_c('ErrorScreen'):_vm._e(),(_vm.GET_IS_CORE_CONTENT_READY)?[(_vm.getBanner)?_c('Banner',{attrs:{"content":_vm.getBanner}}):_vm._e(),_c('Navigation'),_c('AuthPushdown'),_c('div',{staticClass:"bleach-site__store",class:{ 'bleach-site__store--cart-active': _vm.getIsCartActive },attrs:{"id":"scroll-lock-content"}},[_c('router-view')],1),_c('Footer',{attrs:{"content":_vm.GET_SITE_CONFIG.footer}}),_c('modal-container'),(_vm.sourceMode)?_c('EditorControls'):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }